import { schemas } from '#oaf_schema.registry';
import { createStore, createWireStore } from '@oneappexchange/lwc-wired';
import { IS_DEVELOPMENT } from '~/config';
export const BUSINESS_APPROVAL_STATUSES = schemas['business_approval/BusinessApproval'].get().properties.status.enum.reduce((accumulator, current) => ({
  ...accumulator,
  [current]: current
}), {});
const initialState = {
  approvalStatus: BUSINESS_APPROVAL_STATUSES.Draft,
  approvalMessage: ''
};
export const approvalsStore = createStore(initialState, (set, _get) => ({
  /**
   * @returns {boolean} true if pricing initialized successfuly, false if there was an error
   */
  initialize({
    status,
    message
  }) {
    set(function initializing(draft) {
      draft.approvalStatus = status;
      draft.approvalMessage = message;
    });
  },
  reset() {
    set(function reset(draft) {
      draft.approvalStatus = initialState.approvalStatus;
      draft.approvalMessage = initialState.approvalMessage;
    });
  },
  setApprovalStatus(value) {
    set(function setApprovalStatus(draft) {
      draft.approvalStatus = value;
    });
  }
}), 'APPROVALS', IS_DEVELOPMENT);
export const WireApprovalsStore = createWireStore(approvalsStore);
export function selectApprovalStatus(state) {
  return state.approvalStatus;
}